// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 司机管理
import Driver_info from '@/views/driver_mn/Driver_info';

// 区域管理
import Region_mn from '@/views/region_mn/Region_mn';

// 
import Usecar_mn from '@/views/tast_mn/Usecar_mn';

import Regionplan from '@/views/region_mn/Regionplan'
// 车辆管理
import Car_mn from '@/views/car_mn/Car_mn';
// 监管详情
import Regulatory_details from '@/views/car_supervise/Regulatory_details';
// 车辆监管
import car_supervise_mn from '@/views/car_supervise/car_supervise_mn';
// 项目日志
import operationLog_mn from '@/views/projectLog/operationLog_mn';
// 故障日志
import accidentLog_mn from '@/views/projectLog/accidentLog_mn';
// 故障日志
import maintenanceLog_mn from '@/views/projectLog/maintenanceLog_mn';
// 验收日志
import acceptanceLog_mn from '@/views/projectLog/acceptanceLog_mn';
// 维保日志
import repairLog_mn from '@/views/projectLog/repairLog_mn';
// 调度计划
import dispatch_mn from '@/views/dispatch/dispatch_mn';
// 调度任务
import dispatch_task from '@/views/dispatch/dispatch_task';

/**
 * 图标
 */
import home_Page from '@/views/home_page/home_Page';
/**
 * 数据监控
 */

// 工单处理
import WorkOrder_mn from '@/views/worksheet_mn/WorkOrder_mn';
//故障记录
import FaultOrder_mn from '@/views/worksheet_mn/FaultOrder_mn';
//运维配置
import Patrol_mn from '@/views/tast_mn/Patrol_mn';

//综合工单
import zh_work from "@/views/worksheet_mn/zh_work";
//个人中心
import User_mn from '@/views/user_mn/User_mn';
//修改密码
import User_pwd from '@/views/user_mn/User_pwd';
//地图管理
import Map_mn from '@/views/map_mn/Map_mn';
//线路管理
import Line_mn from '@/views/map_mn/Line_mn';
// 站点管理
import Station_mn from '@/views/map_mn/Station_mn';
//车辆运营
import car_operate from "@/views/car_operate/car_operate"
//故障统计
import faultStatistics from "@/views/worksheet_mn/faultStatistics"
//故障类型
import faultType_mn from "@/views/worksheet_mn/faultType_mn"
//故障详情
import faultHistory from "@/views/worksheet_mn/faultHistory"
//首页故障类型
import homeFaultType from "@/views/home_page/faultType/homeFaultType"
//故障车辆类型
import homeFaultCarType from "@/views/home_page/faultType/homeFaultCarType"
//故障车辆
import homeFaultCar from "@/views/home_page/faultType/homeFaultCar"
//里程统计
import mileageStatistics from "@/views/home_page/mileage/mileageStatistics"
//里程详情
import mileageDetails from "@/views/home_page/mileage/mileageDetails"
//车辆数量统计
import carNumber from "@/views/home_page/carNumber"
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 启用路由
Vue.use(Router);
// 导出路由 
export default new Router({
  routes: [{
      path: '/',
      name: '',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/index',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      children: [{
          path: '/user_mn/User_mn',
          name: '个人中心',
          component: User_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user_mn/User_pwd',
          name: '修改密码',
          component: User_pwd,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/driver_mn/Driver_info',
          name: '司机管理',
          component: Driver_info,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/faultType/homeFaultType',
          name: '故障系统',
          component: homeFaultType,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/faultType/homeFaultCarType',
          name: '故障车辆类型',
          component: homeFaultCarType,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/faultType/homeFaultCar',
          name: '故障车辆',
          component: homeFaultCar,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/mileage/mileageStatistics',
          name: '里程统计',
          component: mileageStatistics,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/mileage/mileageDetails',
          name: '里程详情',
          component: mileageDetails,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home_page/carNumber',
          name: '车辆数量统计',
          component: carNumber,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/car_mn/Car_mn',
          name: '车辆管理',
          component: Car_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/car_supervise/car_supervise_mn',
          name: '车辆监管',
          component: car_supervise_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/car_supervise/Regulatory_details',
          name: '监管详情',
          component: Regulatory_details,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/car_operate/car_operate',
          name: '运营统计',
          component: car_operate,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/projectLog/operationLog_mn',
          name: '运营日志',
          component: operationLog_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/projectLog/accidentLog_mn',
          name: '故障日志',
          component: accidentLog_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/projectLog/maintenanceLog_mn',
          name: '保养日志',
          component: maintenanceLog_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/projectLog/acceptanceLog_mn',
          name: '验收日志',
          component: acceptanceLog_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/projectLog/repairLog_mn',
          name: '维保日志',
          component: repairLog_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dispatch/dispatch_mn',
          name: '调度中心',
          component: dispatch_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/dispatch/dispatch_task',
          name: '调度中心',
          component: dispatch_task,
          meta: {
            requireAuth: true
          }
        },

        // --------------------------------------------

        // {
        //   path: '/tast_mn/Usecar_mn',
        //   name: '用车管理',
        //   component: Usecar_mn,
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        // {
        //   path: '/tast_mn/Patrol_mn',
        //   name: '运维配置',
        //   component: Patrol_mn,
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        {
          path: '/region_mn/Region_mn',
          name: '区域管理',
          component: Region_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/region_mn/Regionplan',
          name: '区域计划',
          component: Regionplan,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/worksheet_mn/FaultOrder_mn',
          name: '故障工单',
          component: FaultOrder_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/worksheet_mn/faultStatistics',
          name: '故障统计',
          component: faultStatistics,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/worksheet_mn/faultType_mn',
          name: '故障分类',
          component: faultType_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/worksheet_mn/faultHistory',
          name: '故障详情',
          component: faultHistory,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/worksheet_mn/WorkOrder_mn',
          name: '工单处理',
          component: WorkOrder_mn,
          meta: {
            requireAuth: true
          }
        },
        // {
        //   path: '/operation_mn/zh_work',
        //   name: '综合工单',
        //   component: zh_work,
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        {
          path: '/home_page/home_Page',
          name: '首页',
          component: home_Page,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/map_mn/Map_mn',
          name: '地图管理',
          component: Map_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/map_mn/Line_mn',
          name: '线路管理',
          component: Line_mn,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/map_mn/Station_mn',
          name: '站点管理',
          component: Station_mn,
          meta: {
            requireAuth: true
          }
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js